import { Injectable, NgModuleRef } from '@angular/core';
import { Subscription } from 'rxjs';

@Injectable()
export abstract class ICmsAdminUtilAbstractService {
    protected readonly subscriptions = new Subscription();

    constructor(ngModuleRef: NgModuleRef<any>) {
        ngModuleRef.onDestroy(() => {
            try {
                this.subscriptions.unsubscribe();
                this.destroy();
            } catch (err) {
                console.error(err);
            }
        });
    }

    protected destroy() {}
}
